export enum DisplayingRegionLevel {
  COUNTRY = 'country',
  ZIP = 'zip',
  CITY = 'city',
  METRO_AREA = 'metroArea',
  STATE = 'state',
  NONE = 'none',
}
